import { useContext, useEffect } from 'react'
import MasterModalContext from 'contexts/MasterModalContext'
import GeoContext from 'contexts/geoContext'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { TryShowModalContext } from 'contexts/ModalProvider'
import config from 'constants/config'
import ThereNoPlaceLikeHomePopup from 'home/components/Trip/ThereNoPlaceLikeHomePopup'
import {
  getThereNoPlaceLikeHomePopupMarket,
  getThereNoPlaceLikeHomePopupVariant,
} from 'home/components/Trip/thereNoPlaceLikeHomePopupConfig'
import {
  hasSeenThereNoPlaceLikeHomePopup,
  hasSnoozedThereNoPlaceLikeHomePopupForSession,
  markThereNoPlaceLikeHomePopupAsSeen,
} from 'home/components/Trip/thereNoPlaceLikeHomePopupStorage'

function useShowThereNoPlaceLikeHomePopup() {
  const tryShowModal = useContext(TryShowModalContext)
  const modalState = useContext(MasterModalContext)
  const { currentRegionCode, geoStateName } = useContext(GeoContext)
  const { variation, triggerActivation } = useExperiment(Experiments.thereNoPlaceLikeHomePopup, { canActivate: false })
  const thereNoPlaceLikeHomePopupVariant = getThereNoPlaceLikeHomePopupVariant(variation)
  const thereNoPlaceLikeHomePopupMarket = getThereNoPlaceLikeHomePopupMarket(currentRegionCode, geoStateName)

  useEffect(() => {
    if (
      !config.ENABLE_TRIP_PLANNER ||
      !thereNoPlaceLikeHomePopupMarket ||
      !thereNoPlaceLikeHomePopupVariant ||
      modalState.open ||
      hasSeenThereNoPlaceLikeHomePopup() ||
      hasSnoozedThereNoPlaceLikeHomePopupForSession()
    ) {
      return
    }

    const popup = tryShowModal(
      <ThereNoPlaceLikeHomePopup market={thereNoPlaceLikeHomePopupMarket} variant={thereNoPlaceLikeHomePopupVariant} />,
    )
    if (!popup) {
      return
    }

    triggerActivation()
    markThereNoPlaceLikeHomePopupAsSeen()
  }, [modalState.open, triggerActivation, tryShowModal, thereNoPlaceLikeHomePopupMarket, thereNoPlaceLikeHomePopupVariant])
}

export default useShowThereNoPlaceLikeHomePopup
